export default "__VITE_ASSET__CI4r6Mg5__"